import styled, { css } from 'styled-components'

export const HeaderTitleContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${theme.colors.primary};
    border-radius: ${theme.border.smallRadius};
    margin: 36px;
    padding: 24px;

    > button {
      padding: 0;
      font-weight: ${theme.font.xbold};
      font-size: ${theme.font.sizes.medium};
      width: 2%;
    }
  `}
`

export const HeaderTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.colors.white};
    font-family: ${theme.font.comfortaa};
    font-weight: ${theme.font.xbold};
    font-size: ${theme.font.sizes.normal};
  `}
`
